import { getAllCSVFiles, saveCSVFile } from "../../services/CSVImportServices";
import { START_LOADING, STOP_LOADING } from "./actionTypes";

export const saveCSVFileAction = (data, callback) => async (dispatch, getState) => {
  try {
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveCSVFile(data, token);

    dispatch({ 
      type: 'SAVE_CSV_FILE_SUCCESS', 
      payload: response, 
      requestData: data 
    });

    if (callback) callback(response);
  } catch (error) {
    dispatch({ type: 'SAVE_CSV_FILE_FAILURE', payload: error });
  }
};


export const getAllCSVFilesAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getAllCSVFiles(token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_ALL_CSV_FILES_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_ALL_CSV_FILES_FAILURE', payload: error || 'All CSV Files service failed. Please try again.' });
    }
  }
};